import { authService } from '@/models/auth';
import { useAuthStore } from '@/stores/auth.ts';
import { useSubscriptionStore } from '@/stores/subscription';
import { FeatureFlag } from '@/models/feature-flag';
import { landingRoute } from '@/landing';
export function hasActiveCompany() {
    if (!useAuthStore().company) {
        return { name: 'no-active-company' };
    }
    return undefined;
}
export function canCreateCompany() {
    var _a, _b, _c, _d;
    const featureFlagService = new FeatureFlag();
    const userSubscription = (_b = (_a = useAuthStore()) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.permissions.user_subscription;
    if (userSubscription && useAuthStore().companyCount >= userSubscription.company_limit) {
        return false;
    }
    if (((_d = (_c = useAuthStore()) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.reached_seat_limit) && featureFlagService.can('new-subscription')) {
        useSubscriptionStore().isSeatCheckoutVisible = true;
        return false;
    }
    return undefined;
}
export function permission(name) {
    return (to) => {
        if (authService.can(name)) {
            return undefined;
        }
        // Excluding the guarded route keeps the redirect from looping back into this guard.
        return landingRoute(to.name);
    };
}
/**
 * Keeps a flagged page out of reach while its feature flag is off; the backend refuses its
 * endpoints the same way.
 */
export function feature(flag) {
    return (to) => {
        if (new FeatureFlag().can(flag)) {
            return undefined;
        }
        return landingRoute(to.name);
    };
}
export function trialExpired() {
    var _a;
    if (useAuthStore().trialExpired && ((_a = useAuthStore().user) === null || _a === void 0 ? void 0 : _a.permissions.user_subscription.after_trial_restriction)) {
        return { name: 'plan-expired.index' };
    }
    return undefined;
}
export function mustConfirmEmail() {
    if (!useAuthStore().hasConfirmedEmail) {
        return { name: 'register-confirmation' };
    }
    return undefined;
}
export function emailNotConfirmed() {
    if (useAuthStore().hasConfirmedEmail) {
        return landingRoute();
    }
    return undefined;
}
export function mustCompleteOnboarding() {
    if (!useAuthStore().onboardingCompleted) {
        return { name: 'onboarding' };
    }
    return undefined;
}
export function onboardingCompleted() {
    if (useAuthStore().onboardingCompleted) {
        return landingRoute();
    }
    return undefined;
}
